module.exports = __webpack_public_path__ + "img/xiaochengxu.466517a8.png";